import React, { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

interface GroupboxProps {
  title?: string
  className?: string
  disabled?: boolean
  dataTestId?: string
  children?: React.ReactNode
}

const GroupboxContainer = styled.fieldset`
  border: none;
  border-bottom: 1px solid ${constants.CORE_PRIMARY_3};
  margin-bottom: 19px;

  &:last-child {
    margin-bottom: 0;
  }

  & > * {
    margin-bottom: 19px;
  }
`

const Subtitle = styled.legend<{ disabled?: boolean }>`
  margin-bottom: 12px;
  opacity: ${props => (props.disabled ? '0.24' : '1')};
  font-size: 13px;
  font-weight: ${constants.FontWeight.Bold};
`

export const Groupbox: FunctionComponent<GroupboxProps> = props => {
  return (
    <GroupboxContainer data-test-id={'Groupbox-GroupboxContainer-TitleLabel'} className={props.className}>
      {props.title && <Subtitle disabled={props.disabled}>{props.title}</Subtitle>}
      {props.children}
    </GroupboxContainer>
  )
}
